// AI-CONTEXT: See docs/features/msi-onderbouwing-transparency.md
//
// The onderbouwing document explains the monetary values, it does not
// redefine them: the /database scores[] stay authoritative for every
// calculation. This check surfaces divergence between the two so it can be
// logged — the caller keeps rendering the /database value regardless.

/**
 * Compares the onderbouwing niveaus with the /database scores of the same
 * effect and returns every level whose amounts diverge.
 *
 * @param {Array<{score: number, waardePerJaar: number}>|null} niveaus - Onderbouwing levels
 * @param {Array<{score: number, monetaryValue: number}>|null} scores - /database scores for the same effect
 * @returns {Array<{score: number, waardePerJaar: number, monetaryValue: number}>} mismatches (empty when consistent)
 */
const checkOnderbouwingConsistency = (niveaus, scores) => {
    if (!Array.isArray(niveaus) || !Array.isArray(scores)) return []

    return niveaus.reduce((mismatches, niveau) => {
        const match = scores.find((score) => score.score === niveau.score)
        if (match && match.monetaryValue !== niveau.waardePerJaar) {
            mismatches.push({
                score: niveau.score,
                waardePerJaar: niveau.waardePerJaar,
                monetaryValue: match.monetaryValue,
            })
        }
        return mismatches
    }, [])
}

export default checkOnderbouwingConsistency
